<template>
  <div>
    <sidebar-item
      :link="{
        name: $t('sidebar.dashboard'),
        icon: 'tim-icons icon-chart-pie-36',
        path: {name: 'manager.dashboard'}
      }"
    >
    </sidebar-item>

    <sidebar-item
      :link="{
        name: $t('sidebar.control_tower'),
        icon: 'tim-icons icon-chart-bar-32',
        path: {name: 'manager.marine_control_tower'}
      }"
    >
      <sidebar-item
        :link="{
          name: $t('sidebar.kanban'),
          path: {name: 'manager.control_tower'},
          isRoute: false,
        }" />

      <sidebar-item
        :link="{
          name: $t('sidebar.map'),
          path: {name: 'manager.order_in_progress'},
          isRoute: false,
        }" />
    </sidebar-item>

    <sidebar-item
      :link="{
            name: $t('sidebar.requests'),
            icon: 'tim-icons icon-basket-simple',
          }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
          name: $t('sidebar.request_files'),
          icon: 'playlist_add_check',
          path: {name: 'manager.request_files'},
          isRoute: false,
        }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
          name: $t('sidebar.request'),
          icon: 'playlist_add_check',
          path: {name: 'manager.request'},
          isRoute: false,
        }"
      />
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :material=true
        :link="{
          name: $t('sidebar.road_map'),
          icon: 'map',
          path: {name: 'manager.road_map'},
          isRoute: false,
        }"
      />
      <sidebar-item
        :material=true
        :link="{
          name: $t('sidebar.box'),
          icon: 'map',
          path: {name: 'manager.box'},
          isRoute: false,
        }"
      />
    </sidebar-item>

    <sidebar-item
      :link="{
            name: $t('sidebar.shippings'),
            icon: 'tim-icons icon-coins',
          }"
    >
      <sidebar-item
        :link="{
          name: $t('sidebar.simulation'),
          path: {name: 'manager.order_simulation'},
          isRoute: false,
        }"/>
      <sidebar-item
        :link="{
          name: this.$t('sidebar.quotes'),
          path: {name: 'manager.order_quotes'},
          isRoute: false,
        }"/>
    </sidebar-item>
    <sidebar-item
      :material="true"
      :link="{
      name: 'Importação Maritima',
      icon: 'anchor',
      }"
    >
      <sidebar-item
        :link="{
            name: 'Farol de Navios',
            path: {name: 'manager.marine_dashboard'}
          }">
      </sidebar-item>
      <sidebar-item
        :link="{
            name: 'Cargas Maritimas',
            path: {name: 'manager.marine'}
          }">
      </sidebar-item>
    </sidebar-item>
    <sidebar-item
      :link="{
            name: $t('sidebar.orders'),
            icon: 'tim-icons icon-delivery-fast',
          }"
    >
      <sidebar-item
        :link="{
            name: $t('sidebar.all_orders'),
            path: {name: 'manager.order'}

          }"></sidebar-item>
      <sidebar-item
        :link="{
          name: $t('sidebar.occurrences'),
          path: {name: 'manager.order_occurrences'},
          isRoute: false,
        }"
      />
      <sidebar-item
        :link="{
          name: $t('pages.fob_order.title'),
          path: {name: 'manager.fob_order'},
          isRoute: false
        }"
      />
      <sidebar-item
        :link="{
          name: $t('sidebar.list_documents'),
          path: {name: 'manager.orders_documents'},
          isRoute: false,
        }"/>
      <sidebar-item
        :link="{
          name: $t('placeholders.exports'),
          path: {name: 'manager.orders_exports'},
          isRoute: false,
        }"/>
      <sidebar-item
        :link="{
          name: $t('sidebar.import_cte'),
          path: {name: 'manager.import_cte'},

          }"></sidebar-item>
      <sidebar-item
        :link="{
          name: $t('sidebar.not_imported_files'),
          path: {name: 'manager.not_imported_files'},

          }"></sidebar-item>
      <sidebar-item
        :link="{
            name: $t('sidebar.canceled'),
            path: {name: 'manager.order_canceled'}
          }"></sidebar-item>
      <sidebar-item
        :material="true"
        :link="{
            name: $t('sidebar.address'),
            icon: 'list',
            path: {name: 'manager.address_alias'}
          }"
      />
      <sidebar-item
        :link="{
          name: $t('sidebar.vehicles'),
          icon: 'tim-icons icon-bus-front-12',
          path: {name: 'manager.vehicle'}
        }"/>
    </sidebar-item>
    <sidebar-item
      :material="true"
      :link="{
      name: 'Gerenciamento de Patio',
      icon: 'warehouse',
      }"
    >
      <sidebar-item
        :link="{
            name: 'Controle de Patio',
            path: {name: 'manager.container_control_tower'}
          }">
      </sidebar-item>
      <sidebar-item
        :link="{
            name: 'Lista de Containers',
            path: {name: 'manager.containers'}
          }">
      </sidebar-item>
    </sidebar-item>

    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])
            && $hasRole(role.MANAGER.value)"
      :link="{
        name: $t('sidebar.purchase_order'),
        icon: 'tim-icons icon-cart'
      }"
    >
      <sidebar-item
        :link="{
            name: $t('sidebar.charts'),
            path: {name: 'manager.purchase_order_board'}
          }">
      </sidebar-item>
      <sidebar-item
        :link="{
            name: $t('sidebar.purchase_order'),
            icon: 'tim-icons icon-cart',
            path: {name: 'manager.purchase_order'}

          }">
      </sidebar-item>
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value, permission.BILLING__OWNER.value])"
      :link="{
            name: $t('sidebar.faturas'),
            icon: 'tim-icons icon-money-coins',
          }">
      <sidebar-item
        :link="{
            name: $t('sidebar.current_billing'),
            icon: 'tim-icons icon-shape-star',
            path: {name: 'manager.billing.opened'}
      }"/>
      <sidebar-item
        :link="{
          name: $t('sidebar.billing'),
          icon: 'tim-icons icon-money-coins',
          path: {name: 'manager.billing'}
        }"/>
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value,
        permission.INTEGRA_MANAGER__FINANCIER.value,
        permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
      ])"
      :material="true"
      :link="{
            name: $t('sidebar.reports'),
            icon: 'list',
          }"
    >
      <sidebar-item
        v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
        :link="{
          name: $t('sidebar.list_documents'),
          path: {name: 'manager.orders_documents'},
          isRoute: false,
        }"/>
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ])"
        :link="{
            name: $t('sidebar.orders'),
            icon: 'tim-icons icon-notes',
            path:{name: 'manager.order_export'},
          }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ])"
        :link="{
            name: $t('sidebar.requests'),
            path:{name: 'manager.request_export'},
          }"
      />
      <sidebar-item
        :link="{
          name: $t('sidebar.canhoto_check'),
          icon: 'assignment_turned_in',
          path: {name: 'manager.canhoto'}
        }"
      />
      <sidebar-item
        :link="{
          name: $t('sidebar.nf_files'),
          icon: 'assignment_turned_in',
          path: {name: 'manager.nf_files'}
        }"
      />
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
      :link="{
            name: $t('sidebar.exports_imports'),
            icon: 'tim-icons icon-notes',
          }"
    >
      <sidebar-item
        :link="{
          name: $t('sidebar.list_documents'),
          icon: 'tim-icons icon-notes',
          path:{name: 'manager.orders_documents_export'},
        }"
      />

      <sidebar-item
        :link="{
          name: $t('sidebar.orders'),
          icon: 'tim-icons icon-notes',
          path:{name: 'manager.order_reports'},
        }"
      >
      </sidebar-item>
      <sidebar-item
        :link="{
          name: $t('sidebar.requests'),
          path:{name: 'manager.request_reports'},
        }"
      />
      <sidebar-item
        v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ])"
        :link="{
          name: $t('sidebar.transporters'),
          icon: 'tim-icons icon-notes',
          path:{name: 'manager.transporters_export'},
        }"
      />

      <sidebar-item
        :link="{
          name: $t('sidebar.import_cte'),
          path: {name: 'manager.import_cte'},

      }"></sidebar-item>
    </sidebar-item>
    <sidebar-item
      :material="true"
      :link="{
        name: $t('sidebar.users_and_companies'),
        icon: 'group',
      }"
    >
      <sidebar-item
        :material="true"
        :link="{
            name: $t('sidebar.users'),
            path: {name: 'manager.user'},
            isRoute: false
          }"
      />
      <sidebar-item
        :link="{
             name: $t('sidebar.shippers'),
             path: {name: 'manager.shipper'},
             isRoute: false,
           }"/>
      <sidebar-item
        :link="{
                name: $t('sidebar.transporters'),
                path: {name: 'manager.transporter'},
                isRoute: false,
              }"/>
      <sidebar-item
        :link="{
                name: $t('sidebar.risk_managers'),
                path: {name: 'manager.risk_manager'},
                isRoute: false,
              }"/>
      <sidebar-item
        :link="{
                name: $t('sidebar.brokers'),
                path: {name: 'manager.broker'},
                isRoute: false,
              }"/>
      <!-- <sidebar-item
        :link="{
                name: $t('sidebar.fintechs'),
                path: {name: 'manager.fintech'},
                isRoute: false,
              }"/> -->
      <sidebar-item
        :link="{
                name: $t('sidebar.customers'),
                path: {name: 'manager.customer'},
                isRoute: false,
              }"/>
      <sidebar-item
        :link="{
                name: $t('sidebar.logistics_managers'),
                path: {name: 'manager.four_pl'},
                isRoute: false,
              }"/>
      <sidebar-item
        :link="{
                name: $t('sidebar.finance_managers'),
                path: {name: 'manager.finance_manager'},
                isRoute: false,
              }"/>
      <sidebar-item
        :link="{
                name: $t('sidebar.auditors'),
                path: {name: 'manager.auditor'},
                isRoute: false,
              }"/>
      <sidebar-item
        :link="{
                name: $t('sidebar.drivers'),
                icon: 'tim-icons icon-single-02',
                path: {name: 'manager.driver'}
              }"
      />
        <sidebar-item
          :link="{
            name: $t('sidebar.suppliers'),
            path: {name: 'manager.supplier'},
            isRoute: false
          }"/>
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.INTEGRA_MANAGER__OWNER.value, permission.INTEGRA_MANAGER__ADMIN.value])"
      :material=true
      :link="{
            name: $t('sidebar.settings'),
            icon: 'settings',
            path: {name: 'manager.configuration'}
          }"
    >
    </sidebar-item>
  </div>
</template>

<script>
import userPermission from "@/util/valueObjects/userPermission";
import userRole from "@/util/valueObjects/userRole";

export default {
  name: "sidebar",
  data() {
    return {
      role: userRole,
      permission: userPermission,
    }
  }
}
</script>

<style scoped>

</style>
